import { CustodyType } from '@ndvr/portfolio-api';

// Validate against supported brokers, rather than guessing from arbitrary separators.
const brokerIds = new Set<string>(Object.values(CustodyType));

export const toBrokerAccountId = (brokerId: string, accountNumber: string): string => {
    if (!brokerIds.has(brokerId) || !accountNumber || accountNumber.trim() !== accountNumber) {
        throw new Error('Invalid broker account ID');
    }
    return `${brokerId}_${accountNumber}`;
};

export const parseBrokerAccountId = (id: string): { brokerId: string; accountNumber: string } => {
    const separator = id.indexOf('_');
    if (separator <= 0) throw new Error('Invalid broker account ID');
    const brokerId = id.slice(0, separator);
    const accountNumber = id.slice(separator + 1);
    toBrokerAccountId(brokerId, accountNumber);
    return { brokerId, accountNumber };
};
